/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import TIM from 'tim-js-sdk';
// import COS from 'cos-js-sdk-v5';
import { Toast } from 'antd-mobile';
import '@/styles/chat.scss';
import { getUser, checkLogin } from '../../utils';
import { getUserSign } from '@/services/saas/conference';

class IMChat extends Component {
  isGroupMaster = false;

  state = {
    chatList: [],
    memberList: [],
    tabList: [
      { id: 'chatList', name: '聊天室' },
      { id: 'members', name: '成员' },
    ],
    selectedId: 'chatList',
    initSuccess: false,
  };

  componentDidMount() {
    checkLogin({
      onLogin: () => {
        this.init();
        window.onbeforeunload = function (e) {
          this.quitGroup();
        };
        document.onkeydown = (e) => {
          var theEvent = window.event || e;
          var code = theEvent.keyCode || theEvent.which || theEvent.charCode;
          if (code === 13) {
            this.sendMsg(e);
          }
        };
      },
    });
  }

  componentWillUnmount() {
    if (this.tim) {
      this.quitGroup();
      this.isUnmount = true;
    }
    document.onkeydown = null;
  }

  imCatchEvent = () => {
    this.tim.on(TIM.EVENT.SDK_READY, this.imReaday);
    this.tim.on(TIM.EVENT.MESSAGE_RECEIVED, (event) => this.imReceiveMessage(event));
  };

  quitGroup = async () => {
    const { groupId } = this.props;
    if (!this.isGroupMaster) {
      let msg = this.tim.createCustomMessage({
        to: groupId,
        conversationType: TIM.TYPES.CONV_GROUP,
        payload: {
          data: 'out',
        },
      });
      await this.tim.sendMessage(msg);
      await this.tim.quitGroup(groupId);
    }
    this.tim.logout();
  };

  imReceiveMessage = async (msg) => {
    // console.log(msg);
    if (msg) {
      const { chatList } = this.state;
      if (msg.data[0].type === 'TIMTextElem') {
        chatList.push({
          user: msg.data[0].nick,
          avatar: msg.data[0].avatar,
          text: msg.data[0].payload.text,
        });
        await this.setState({
          chatList,
        });
        const messageList = this.refs.messageList;
        if (messageList.scrollHeight) {
          messageList.scrollTop = messageList.scrollHeight - messageList.clientHeight;
        }
      }
      if (
        msg.data[0].type === 'TIMCustomElem' &&
        (msg.data[0].payload.data === 'in' || msg.data[0].payload.data === 'out')
      ) {
        const { groupId } = this.props;
        this.getMember(groupId);
      }
    }
  };

  imCreateGroup = (callback) => {
    const { groupName, groupId } = this.props;
    const { userId } = getUser();
    this.tim
      .searchGroupByID(groupId)
      .then(async (respGroup) => {
        if (respGroup && respGroup.code === 0) {
          const respJoin = await this.tim.joinGroup({
            groupID: groupId,
            type: TIM.TYPES.GRP_CHATROOM,
          });
          if (respJoin && respJoin.code === 0) {
            let joinStatusMessage = '';
            if (respJoin.data.status === TIM.TYPES.JOIN_STATUS_WAIT_APPROVAL) {
              joinStatusMessage = '等待管理员审核';
            }
            if (respJoin.data.status === TIM.TYPES.JOIN_STATUS_SUCCESS) {
              joinStatusMessage = '加群成功';
              let msg = this.tim.createCustomMessage({
                to: groupId,
                conversationType: TIM.TYPES.CONV_GROUP,
                payload: {
                  data: 'in',
                },
              });
              this.tim.sendMessage(msg);
              if (callback) {
                callback(groupId);
              }
            }
            if (respJoin.data.status === TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP) {
              joinStatusMessage = '已在群中';
              let msg = this.tim.createCustomMessage({
                to: groupId,
                conversationType: TIM.TYPES.CONV_GROUP,
                payload: {
                  data: 'in',
                },
              });
              this.tim.sendMessage(msg);
              if (callback) {
                callback(groupId);
              }
            }
            if (userId === respGroup.data.group.ownerID) {
              this.isGroupMaster = true;
            }
            console.log(joinStatusMessage);
          }
        }
      })
      .catch(async (err) => {
        const respCreateGroup = await this.tim.createGroup({
          name: groupName, //群组名称，最长30字节
          // TIM.TYPES.GRP_PRIVATE：私有群，默认
          // TIM.TYPES.GRP_PUBLIC：公开群
          // TIM.TYPES.GRP_CHATROOM：聊天室
          // TIM.TYPES.GRP_AVCHATROOM：互动直播聊
          type: TIM.TYPES.GRP_CHATROOM,
          groupID: groupId, //群组 ID。不填该字段时，会自动为群组创建一个唯一的群 ID
          introduction: '', //群简介，最长240字节
          notification: '', //群公告，最长300字节
          avatar: '', //群头像 URL，最长100字节
          // maxMemberNum: 200, //最大群成员数量，默认值：私有群为200，公开群为2000，聊天室为6000，音视频聊天室无限制
          // 申请加群处理方式。创建私有群/ 聊天室 / 音视频聊天室时不能填写该字段。私有群该字段固定为：禁止申请加群，聊天室和音视频聊天室该字段固定为：自由加入
          // TIM.TYPES.JOIN_OPTIONS_FREE_ACCESS：自由加入
          // TIM.TYPES.JOIN_OPTIONS_NEED_PERMISSION：需要验证
          // TIM.TYPES.JOIN_OPTIONS_DISABLE_APPLY：禁止加群
          joinOption: TIM.TYPES.JOIN_OPTIONS_FREE_ACCESS,
          memberList: [], // 初始群成员列表，最多500个。创建音视频聊天室时不能添加成员
          groupCustomField: [], //群组维度的自定义字段，默认没有自定义字段
        });
        if (respCreateGroup && respCreateGroup.code === 0) {
          console.log('创建成功');
          console.log(respCreateGroup.data.group); //创建的群的资料
          this.isGroupMaster = true;
          if (callback) {
            callback(groupId);
          }
        } else {
          console.warn('createGroup error:'); // 创建群组失败的相关信息
        }
      });
  };

  getMember = (groupId) => {
    this.tim.getGroupMemberList({ groupID: groupId }).then((groupMembers) => {
      //获取群组成员列表
      if (!this.isUnmount) {
        this.setState({
          memberList: groupMembers.data.memberList.map((item) => ({
            id: item.userID,
            userName: item.nick,
          })),
        });
      }
    });
  };

  imReaday = () => {
    this.updateUserProfile();
    this.imCreateGroup((groupId) => this.getMember(groupId));
  };

  sendMsg = (e) => {
    e.preventDefault();
    const msgInput = this.refs.messageInput;
    const sendMessage = msgInput.value;
    const { groupId } = this.props;
    const { nickName, userId } = getUser() || {};
    if (!userId) {
      Toast.info('请先登录');
      return;
    }
    if (sendMessage) {
      const message = this.tim.createTextMessage({
        to: groupId,
        conversationType: TIM.TYPES.CONV_GROUP,
        payload: { text: sendMessage },
      });
      this.tim
        .sendMessage(message)
        .then(async (sendResp) => {
          if (sendResp.code === 0) {
            console.log('发送成功');
            msgInput.value = '';
            const { chatList } = this.state;
            chatList.push({
              user: nickName,
              avatar: sendResp.data.message.avatar,
              text: sendResp.data.message.payload.text,
              isMine: true,
            });
            await this.setState({ chatList });
            const messageList = this.refs.messageList;
            messageList.scrollTop = messageList.scrollHeight - messageList.clientHeight;
          } else {
            console.log('发送失败');
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  updateUserProfile = () => {
    const { nickName } = getUser();
    this.tim
      .updateMyProfile({ nick: nickName })
      .then((profile) => {
        // console.log(profile);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  catchError = async (callback) => {
    const { userId } = getUser() || {};
    if (!userId) {
      Toast.info('请先登录');
      return;
    }
    const signResp = await getUserSign({ userId });
    if (signResp.success) {
      const { appId, userSign } = signResp.data;
      if (!userId) {
        Toast.info('userId is required');
        return;
      }
      if (!appId) {
        Toast.info('appId is required');
        return;
      }
      if (!userSign) {
        Toast.info('userSign is required');
        return;
      }
      if (callback) {
        await this.setState({ initSuccess: true });
        callback(userId, appId, userSign);
      }
    } else {
      Toast.info(signResp.meg || '获取appId及userSign失败！');
    }
  };

  init = () => {
    this.catchError((userID, SDKAppID, userSig) => {
      const tim = TIM.create({ SDKAppID });
      this.tim = tim;
      tim.setLogLevel(4);
      // tim.registerPlugin({ 'cos-js-sdk': COS });
      this.imCatchEvent();
      tim.login({ userID, userSig });
    });
  };

  onTabChange = (id) => {
    this.setState({
      selectedId: id,
    });
  };

  render() {
    const { chatList, memberList, tabList, selectedId, initSuccess } = this.state;
    const chatListDom = (
      <Fragment>
        <ul className="chat-list" ref="messageList">
          {chatList.map((item, index) => (
            <li className={`item${item.isMine ? ' mine' : ''}`} key={index}>
              <p className="user-name">{item.isMine ? '我' : item.user}</p>
              <p className="content">{item.text}</p>
            </li>
          ))}
        </ul>
        {initSuccess ? (
          <div className="send-box">
            <input type="text" ref="messageInput" />
            <em onClick={this.sendMsg}>发送</em>
          </div>
        ) : null}
      </Fragment>
    );
    const memberListDom = (
      <ul className="member-list">
        {memberList.map((item) => (
          <li key={item.id} className="item">
            {item.userName}
          </li>
        ))}
      </ul>
    );
    return (
      <div className="chat">
        <div className="tab">
          {tabList.map((item) => (
            <span
              key={item.id}
              className={`item ${selectedId === item.id ? ' on' : ''}`}
              onClick={() => this.onTabChange(item.id)}
            >
              {item.name}
              <span style={{ color: '#91f891' }}>
                {item.id === 'members' ? `(${memberList.length})` : null}
              </span>
            </span>
          ))}
        </div>
        <div className="tab-panel">{selectedId === 'chatList' ? chatListDom : memberListDom}</div>
      </div>
    );
  }
}

export default IMChat;
